import React from 'react';

import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import { cn } from '@/src/util/ui';

const ELLIPSIS_LABEL = '...';
// Label should still be the exact maxLength count
type LongTextEllipsisInBetweenProps = {
  value: string;
  id: string | number;
  maxLength: number;
  firstCharactersLength: number;
  lastCharactersLength: number;
  className?: string;
  tooltipClassName?: string;
};

const getLabel = ({ value, maxLength, firstCharactersLength, lastCharactersLength }) => {
  if (value.length < maxLength) {
    return value;
  }

  return (
    value.substring(0, firstCharactersLength) + ELLIPSIS_LABEL + value.slice(-lastCharactersLength)
  );
};

const LongTextEllipsisInBetween = ({
  value,
  id,
  maxLength,
  firstCharactersLength,
  lastCharactersLength,
  className = '',
  tooltipClassName = '',
}: LongTextEllipsisInBetweenProps) => {
  if (value.length < maxLength) {
    return (
      <span
        style={{
          overflowWrap: 'anywhere',
        }}
      >
        {value}
      </span>
    );
  }

  const tooltipId = `lte_${id}`;
  const label = getLabel({ value, maxLength, lastCharactersLength, firstCharactersLength });

  return (
    <>
      <span
        style={{
          overflowWrap: 'anywhere',
        }}
        className={cn(className)}
        data-tooltip-id={tooltipId}
      >
        {label}
      </span>

      <Tooltip className={cn(tooltipClassName)} id={tooltipId} place="bottom" effect="solid">
        {value}
      </Tooltip>
    </>
  );
};

export default LongTextEllipsisInBetween;
